
import {  useSelector,useDispatch } from 'react-redux'
import { editCompanyAction } from '../../../../../redux/reducer/editCompoany/action/action'
import { Input ,Button, ButtonToolbar } from 'rsuite';
import { Checkbox, CheckboxGroup } from '@chakra-ui/react'
import Spinner from 'react-bootstrap/Spinner';
import { useState } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { getMyCompany } from '../../../../../redux/reducer/getCompany/action/action';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { getCompanyForChangeAPI } from '../../../../../redux/reducer/myCompanyAPI/action/action';

import { useToast } from '@chakra-ui/react'

export default function EditCompanyOptions({items}) {

  const getDarkModoe = useSelector(darkModes => darkModes )
  const toast = useToast()

    const [loading,setLoading] = useState(false)

    const getCompany = useSelector(company=> company)
    const dispatch = useDispatch()
  const  navigate = useNavigate()

    const [disabled,setDisabled] = useState(false)
    const [inn,SETinn] = useState("")








        const addCompany=(e)=>{
        
            setLoading(true)
            setDisabled(true)
            dispatch(getMyCompany("/mycopany/getallcompany"))
            e.preventDefault() 
            axios.patch("/mycopany/edit", {
                data:{
                    inn:e.target.inn.value,
                    sellersname:e.target.sellersname.value,
                    indirecttax:e.target.indirecttax.checked,
                    Legaladdress:e.target.Legaladdress.value,
                    Checkingaccount:e.target.Checkingaccount.value,
                    btc:e.target.btc.value,
                    ognip:e.target.ognip.value,
                    companyID:getCompany.getMyCompanyAPIReducer.company._id
                }
                
             
          })
            .then(function (response) {
              setLoading(false)
              setDisabled(false)
             
            
              swal(response.data.message);
             
              swal("Хорошая работа!", response.data.message, "success");
              dispatch(getMyCompany("/mycopany/getallcompany"))
              dispatch(getCompanyForChangeAPI("/changeapi/api"))
            })
            .catch(function (error) {
              console.log(error);
              setLoading(false)
              setDisabled(false)
              toast({
                position:"top-right",
                title: 'Ошибка',
                description: error.response.data.message,
                status: 'error',
                duration: 3000,
                isClosable: true,
              })
              
            });
          }
          
            
  
            if (getCompany.getMyCompanyAPIReducer.company != "" && getCompany.getMyCompanyAPIReducer.company != undefined ) {
                return(
                  <div className={getDarkModoe.ToggleDarkModeReducer.chekced?"settingsContDark":"settingsCont"}>
             
                    <p className='editTitle'>Редактирование компании</p>
                    <form  onSubmit={addCompany}>
                        {/* <div className='formchildCont1'>
                          <label htmlFor="">ИНН</label>
                          <Input placeholder="ИНН" name='inn' defaultValue={getCompany.getMyCompanyAPIReducer.company.inn} key={getCompany.getMyCompanyAPIReducer.company.inn + 1}/>
                          <label htmlFor="">Наименование продавца</label>
                          <Input placeholder="наименование продавца" name='sellersname' defaultValue={getCompany.getMyCompanyAPIReducer.company.sellersname} key={getCompany.getMyCompanyAPIReducer.company.inn + 2} />
                          <div className='chekcbox' color='#5E80E4'> <Checkbox  name='indirecttax' defaultChecked={getCompany.getMyCompanyAPIReducer.company.indirecttax} key={getCompany.getMyCompanyAPIReducer.company.indirecttax+3}>С НДС</Checkbox></div>
                          <label htmlFor="">Юридический адрес</label>
                          <Input as="textarea" rows={4} placeholder="Юридический адрес" defaultValue={getCompany.getMyCompanyAPIReducer.company.Legaladdress} key={getCompany.getMyCompanyAPIReducer.company.Legaladdress+4} name='Legaladdress'/>
                         <div className='forDekstopbtn'>
                         {loading?
                           <Button variant="primary" disabled style={{backgroundColor:"#5E83E0"}}>
                           <Spinner
                             as="span"
                             animation="grow"
                             size="sm"
                             role="status"
                             aria-hidden="true"
                           />
                           загрузка...
                         </Button>
                          :
                          <Button colorScheme='blue' type='submit'  style={{backgroundColor:"#5E80E4"}}>Редактировать</Button>
                          }
                         </div>
                          
                        </div>
                        <div className='formchildCont1'>
                          <label htmlFor="">Расчётный счёт</label>
                          <Input placeholder="Расчётный счёт" name='Checkingaccount' defaultValue={getCompany.getMyCompanyAPIReducer.company.Checkingaccount } key={getCompany.getMyCompanyAPIReducer.company.Checkingaccount + 5} />
            
                          
                          <label htmlFor="">БИК</label>
                          <Input placeholder="БИК" name='btc' defaultValue={getCompany.getMyCompanyAPIReducer.company.btc} key={getCompany.getMyCompanyAPIReducer.company.btc + 6}/>
                          <label htmlFor="">ОГРН (ОГРНИП)</label>
                          <Input placeholder="ОГРНИП" name='ognip' defaultValue={getCompany.getMyCompanyAPIReducer.company.ognip} key={getCompany.getMyCompanyAPIReducer.company.ognip + 7} />
                          
                         
                        </div>
                        <div className='forMobilebtn'>
                         {loading?
                           <Button variant="primary" disabled style={{backgroundColor:"#5E83E0"}}>
                           <Spinner
                             as="span"
                             animation="grow"
                             size="sm"
                             role="status"
                             aria-hidden="true"
                           />
                           загрузка...
                         </Button>
                          :
                          <Button colorScheme='blue' type='submit'  style={{backgroundColor:"#5E80E4"}}>Редактировать</Button>
                          }
                         </div>
                          */}


                         {/*  */}
                               <div className='child1'>    
                              <input placeholder="ИНН" name='inn' defaultValue={getCompany.getMyCompanyAPIReducer.company.inn} key={getCompany.getMyCompanyAPIReducer.company.inn + 1}/>          
                              <input placeholder="Наименование продавца" name='sellersname'  defaultValue={getCompany.getMyCompanyAPIReducer.company.sellersname} key={getCompany.getMyCompanyAPIReducer.company.inn + 2}  />
                              </div>
                              <div className='child2'>
                              <textarea as="textarea" rows={4} placeholder="Юридический адрес" name='Legaladdress' defaultValue={getCompany.getMyCompanyAPIReducer.company.Legaladdress} key={getCompany.getMyCompanyAPIReducer.company.Legaladdress+4}/>
                              </div>
                              <div className='child3'>
                              <input placeholder="Расчётный счёт" name='Checkingaccount'  defaultValue={getCompany.getMyCompanyAPIReducer.company.Checkingaccount } key={getCompany.getMyCompanyAPIReducer.company.Checkingaccount + 5}/>
                              <input placeholder="БИК" name='btc' defaultValue={getCompany.getMyCompanyAPIReducer.company.btc} key={getCompany.getMyCompanyAPIReducer.company.btc + 6}/>
                           </div>
                            <div className='child4'>
                                <input placeholder="ОГРНИП" name='ognip'  className='ognip' defaultValue={getCompany.getMyCompanyAPIReducer.company.ognip} key={getCompany.getMyCompanyAPIReducer.company.ognip + 7}/>
                                {/* <Checkbox  name='indirecttax' className='indirecttax'>С НДС</Checkbox> */}
                                    <div className='checkboxDiv'>
                                      
                                      <input type="checkbox"  name='indirecttax' className='indirecttax'  defaultChecked={getCompany.getMyCompanyAPIReducer.company.indirecttax} key={getCompany.getMyCompanyAPIReducer.company.indirecttax+3}></input>
                                      <p> С НДС</p>
                                    </div>
                                {loading?
                            <button variant="primary" disabled style={{backgroundColor:"#5E83E0"}}>
                            <Spinner
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                            загрузка...
                          </button>
                            :
                            <button colorScheme='blue' type='submit'  >Редактировать компанию</button>
                            }
                            </div>
                    </form>
                    {/* <button>Редактировать данные продавца</button> */}
                   
                   
                  </div>
                )
            }else{
               return  <h1>у вас нет компании</h1>
            }
            
}